import invariant from 'tiny-invariant';
import { IncomingHttpHeaders } from 'http';
import getConfig from 'next/config';

type apiConfig = {
  host: string;
  scheme: string;
  origin: string;
};

const apiConfig = (headers?: IncomingHttpHeaders): apiConfig => {
  let host = '';
  if (headers && headers['application-domain']) {
    host = headers['application-domain'].toString();
  } else if (headers && headers.host) {
    host = headers.host;
  } else if (typeof window === 'object') {
    host = location.host;
  }

  invariant(host, 'No HOST header provided or no location object available.');

  const scheme = getConfig().publicRuntimeConfig.ENV === 'development' ? 'http:' : 'https:';

  return {
    host,
    scheme,
    origin: `${scheme}//${host}`,
  };
};

export { apiConfig };
